import { useEffect, useState } from "react";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { Stack } from "@mantine/core";
import { NavLink } from "@mantine/core";
import { Text } from "@mantine/core";
import { Avatar } from "@mantine/core";
import { IconActivityFeed } from "../../assets/icon/menu/IconActivityFeed";
import { IconLifetimeAnalytics } from "../../assets/icon/menu/IconLifetimeAnalytics";
import { useNavigate, useLocation } from "react-router-dom";
import colorsCustom from "../../designTokens/colorsCustom";
import { getColor } from "../../designTokens/colorTokens";
import { IconSearch } from "@tabler/icons-react";
import { IconBooks } from "@tabler/icons-react";
// removed unused IconMessageChatbot import
import { IconUsers } from "@tabler/icons-react";
import { IconSend } from "@tabler/icons-react";
import { IconMessageCircle } from "@tabler/icons-react";
// removed unused IconCalendarMonth import
import { IconBook2 } from "@tabler/icons-react";
import { IconBookmark } from "@tabler/icons-react";
import { IconPlan } from "../../assets/icon/menu/IconPlan";
import { IconBulb } from "@tabler/icons-react";
import { IconDeviceGamepad2 } from "@tabler/icons-react";
import { IconSparkles } from "@tabler/icons-react";
import GradientBox from "../patterns/color/GradientBox";
import { useTranslation } from "react-i18next";
import { Group } from "@mantine/core";
import { Link } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";
import { IconX } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";
import colors from "../../designTokens/colors.esm";
import { checkAdminPermission } from "../../services/adminAuth";
import { IconShield } from "@tabler/icons-react";


export const SideMenu = ({ userData, toggle, forceMobileView = false }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
    const isMobileBase = useIsMobile("xl");
    const isMobile = forceMobileView || isMobileBase;
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		let isMounted = true;

		const fetchPermission = async () => {
			if (!userData?.id) {
				if (isMounted) {
					setIsAdmin(false);
				}
				return;
			}

			try {
				const hasPermission = await checkAdminPermission(userData.id);
				if (isMounted) {
					setIsAdmin(Boolean(hasPermission));
				}
			} catch (error) {
				if (isMounted) {
					setIsAdmin(false);
				}
			}
		};

		fetchPermission();

		return () => {
			isMounted = false;
		};
	}, [userData?.id]);
	const menuList1 = [
		{
			title: t("sidebar.activityFeed"),
			icon: <IconActivityFeed />,
			link: "/dashboard",
		},
		{
			title: t("sidebar.lifetimeAnalytics"),
			icon: <IconLifetimeAnalytics />,
			link: "/analytic",
		},
		{
			title: t("sidebar.searchThreads"),
			icon: <IconSearch size={24} />,
			link: "/search",
		},
		{
			title: t("sidebar.friendsInteraction"),
			icon: <IconMessageCircle size={24} />,
			link: "/friends-interaction",
		},

		// {
		// 	title: "Repost Curation",
		// 		icon: <IconRepostCuration />,
		// 		link: "/repost-curation",
		// },
	];

	const menuListWriting = [
		{
			title: t("sidebar.postThread"),
			icon: <IconSend size={24} />,
			link: "/post-thread",
		},
		// {
		// 	title: t("sidebar.ideation"),
		// 	icon: <IconBulb size={24} />,
		// 	link: "/ideation",
		// },
	];
	const menuList2 = [
		{
			title: t("sidebar.myCollection"),
			icon: <IconBooks size={24} />,
			link: "/my-page",
		},
		{
			title: t("sidebar.yearEnd"),
			icon: <IconSparkles size={24} />,
			link: "/year-end",
		},
		{
			title: t("sidebar.yearInReview"),
			icon: <IconSparkles size={24} />,
			link: "/year-in-review",
		},
		{
			title: "Bookmarks",
			icon: <IconBookmark size={24} />,
			link: "/bookmarks",
		},
		{
			title: "Letter Tetris",
			icon: <IconDeviceGamepad2 size={24} />,
			link: "/letter-tetris",
		},
		{
			title: t("sidebar.monthlyThreads"),
			icon: <IconBook2 size={24} />,
			link: "/monthly-threads",
			newWindow: true,
		},
		{
			title: t("sidebar.threadsPeople"),
			icon: <IconUsers size={24} />,
			link: "/people",
			newWindow: true,
		},
		// {
		// 	title: "All Threaders",
		// 	icon: <IconUsers size={24} />,
		// 	link: "/threaders",
		// },
	];

	const menuList3 = [
		{
			title: t("sidebar.myAccount"),
			icon: <Avatar size={24} src={userData.threads_profile_picture_url} />,
			link: "/account",
		},
		{
			title: t("sidebar.pricing"),
			icon: <IconPlan size={24} />,
			link: "/pricing",
		},
		// {
		// 	title: "Manage My Plan",
		// 	icon: <IconPlan />,
		// 	link: "/plan",
		// },
	];
	return (
		<CardContainerRetro
			bg={colorsCustom.paper}
			w={"100%"}
			h={"100%"}
			rd={isMobile ? 0 : 16}
			weight="bold"
		>
			<Stack
				gap={16}
				w={"100%"}
				h={"100%"}
				pb={16}
				style={{
					overflowY: "visible",
					WebkitOverflowScrolling: "touch",
					minHeight: 0,
					flex: "1 1 auto",
				}}
			>
				{/* 모바일에서만 닫기 버튼 표시 */}
				{isMobile && (
					<Group
						justify="space-between"
						p="16 16 8 16"
						style={{
							position: "sticky",
							top: 0,
							zIndex: 2,
							background: colorsCustom.paper,
							backdropFilter: "blur(6px)",
							borderBottom: "1px solid var(--mantine-color-gray-2)",
						}}
					>
						<Text size="lg" fw={600} c="dark">
							Menu
						</Text>
						<ActionIcon
							variant="subtle"
							size="lg"
							onClick={toggle}
							aria-label="Close menu"
						>
							<IconX size={20} />
						</ActionIcon>
					</Group>
				)}
				<Stack
					p={"16 0 0 0"}
					gap={0}
					w={"100%"}
					style={{ borderBottom: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Stack p={"8 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Insight & Content
						</Text>
						{menuList1.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								p={"12 16"}
								w={"100%"}
								fw={location.pathname === item.link ? 800 : 500}
								fs={"sm"}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.md,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
						))}
					</Stack>
				</Stack>
				<Stack
					p={"16 0 0 0"}
					gap={0}
					w={"100%"}
					style={{ borderBottom: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Stack p={"8 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Writing
						</Text>
						{menuListWriting.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								p={"12 16"}
								w={"100%"}
								fw={location.pathname === item.link || location.pathname.startsWith(item.link + "/") ? 800 : 500}
								fs={"sm"}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.md,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
						))}
					</Stack>
				</Stack>
				<Stack
					p={"16 0 0 0"}
					gap={0}
					w={"100%"}
					style={{ borderBottom: "1px solid var(--mantine-color-gray-2)" }}
				>
					<Stack p={"8 0"} gap={0}>
						<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
							Collections
						</Text>
						{menuList2.map((item) => (
							item.gradient ? (
								<GradientBox
									key={item.title}
									palette={[colors.inkGray[9], colors.inkGray[6]]}
									type="linear"
									contrast="ambient"
									angle={45}
									animated={true}
									animationDuration={2}
									sx={{
										width: "100%",
										minHeight: "auto",
										padding: 0,
										borderRadius: 0,
										display: "flex",
										alignItems: "stretch",
									}}
								>
									<NavLink
										label={item.title}
										leftSection={item.icon}
										p={"12 16"}
										w={"100%"}
										fw={location.pathname === item.link || location.pathname.startsWith(item.link) ? 800 : 500}
										fs={"sm"}
										onClick={() => {
											if (item.newWindow) {
												window.open(item.link, "_blank");
											} else {
												navigate(item.link);
											}
											toggle();
										}}
										styles={(theme) => ({
											root: {
												backgroundColor: "transparent",
												border: "none",
												width: "100% !important",
												minWidth: "100%",
												flex: "1 1 100%",
												boxSizing: "border-box",
												margin: 0,
												"&:hover": {
													backgroundColor: "transparent",
												},
											},
											label: {
												fontSize: theme.fontSizes.md,
												color: getColor('white', '50'),
											},
											section: {
												marginRight: theme.spacing.md,
												color: getColor('white', '50'),
											},
										})}
									/>
								</GradientBox>
							) : (
								<NavLink
									key={item.title}
									label={item.title}
									leftSection={item.icon}
									p={"12 16"}
									w={"100%"}
									fw={location.pathname === item.link || location.pathname.startsWith(item.link) ? 800 : 500}
									fs={"sm"}
									onClick={() => {
										if (item.newWindow) {
											window.open(item.link, "_blank");
										} else {
											navigate(item.link);
										}
										toggle();
									}}
									styles={(theme) => ({
										label: {
											fontSize: theme.fontSizes.md,
										},
										section: {
											marginRight: theme.spacing.md,
										},
									})}
								/>
							)
						))}
					</Stack>
				</Stack>
		{userData && (
			<Stack p={"16 0 0 0"} gap={0}>
				<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
					Setting & Account
				</Text>
				{menuList3.map((item) => (
							<NavLink
								key={item.title}
								label={item.title}
								leftSection={item.icon}
								w={"100%"}
								p={"12 16"}
								fs={"sm"}
								fw={location.pathname === item.link ? 800 : 500}
								onClick={() => {
									navigate(item.link);
									toggle();
								}}
								styles={(theme) => ({
									label: {
										fontSize: theme.fontSizes.md,
									},
									section: {
										marginRight: theme.spacing.md,
									},
								})}
							/>
				))}
			</Stack>
		)}
		{isAdmin && (
			<Stack p={"16 0 0 0"} gap={0}>
				<Text size={"md"} fw={600} c={"gray.5"} mb={"16"} ml={20}>
					{t("sidebar.admin")}
				</Text>
				<NavLink
					label={t("sidebar.admin")}
					leftSection={<IconShield size={24} />}
					w={"100%"}
					p={"12 16"}
					fs={"sm"}
					fw={location.pathname === "/admin" || location.pathname.startsWith("/admin/") ? 800 : 500}
					onClick={() => {
						navigate("/admin");
						toggle();
					}}
					styles={(theme) => ({
						label: {
							fontSize: theme.fontSizes.md,
						},
						section: {
							marginRight: theme.spacing.md,
						},
					})}
				/>
			</Stack>
		)}
			<Group
				gap={8}
				justify="center"
						pt={8}
						style={{ borderTop: "1px solid var(--mantine-color-gray-2)" }}
					>
					<Link to="/privacy" style={{ textDecoration: "none" }}>
						<Text size="sm" c="dimmed">
							{t("legal.privacy.shortTitle")}
						</Text>
					</Link>
					<Text size="sm" c="dimmed">
						•
					</Text>
					<Link to="/terms" style={{ textDecoration: "none" }}>
						<Text size="sm" c="dimmed">
							{t("legal.tos.shortTitle")}
						</Text>
					</Link>
				</Group>
			</Stack>
		</CardContainerRetro>
	);
};
